import template from './app.html';

let component = {
	template,
	controller: function(
		$ionicHistory, 
		$scope,
		Customer,
		Product,
		Basket,
		$ionicModal,
		$cordovaBarcodeScanner,
		$ionicPopup,
		$ionicPlatform,
		$timeout,
		$filter,
		$state,
		$window
	) {
		"ngInject";
		
		var vm = this;

		vm.showOverwriteButton = false;

		vm.back = function() {
			if ($ionicHistory.backView()) {
				$ionicHistory.backView().go();
			}
		}

		vm.active = Boolean(Customer.session());

		vm.toggleCustomer = function() {
			if(!vm.active) {
				Customer.create();
			} else {
				$scope.modal = $ionicModal.fromTemplate('<evaluation modal="modal"></evaluation>', {
					scope: $scope,
					animation: 'slide-in-up',
					backdropClickToClose: false,
					hardwareBackButtonClose: false
				});
				$scope.modal.show();
			}
		}

		vm.scan = function() {
			$ionicPlatform.ready(function() {
				if (window.cordova) {
					vm.scanning = true;
					$cordovaBarcodeScanner.scan().then(result => {
						console.log(result);
						return Product.find({ean: result.text}).then(result => {
							$ionicHistory.nextViewOptions({
								disableBack: true
							});
							$state.go('tab.product', {uid: result.id, ref:'scan'}, {ignoreDsr: true});
						});
						
					}).catch(err => {
						$ionicPopup.alert({
							title: $filter('translate')('product_not_found'),
							subTitle: $filter('translate')('product_not_found_subtitle'),
							okType: 'button-assertive'
						});
					}).finally(() => {
						vm.scanning = false;
					});
				} else {
					var ean = $window.prompt('Enter EAN or article number');

					if (ean != null) {
						Product.find({ean: ean}).then(result => {
							$ionicHistory.nextViewOptions({
								disableBack: true
							});
							$state.go('tab.product', {uid: result.id, ref:'scan'}, {ignoreDsr: true});
						});
					}
				}
			});
		}

		$scope.$on('CUSTOMER_CHANGED', function(e) {
			vm.active = Boolean(Customer.session());
		});
	}
}

export default component;


// WEBPACK FOOTER //
// ./app/app.component.js